import { call, takeEvery, takeLatest } from 'redux-saga/effects';
import * as constants from './agenda-items.constants';

import * as types from './agenda-items.types';
import * as services from './agenda-items.saga-services';

function* invokeGetAgendaItems(action: types.IGetAgendaItems) {
  yield call(services.getAgendaItems, action.payload);
}

function* invokeSaveAgendaItems(action: types.ISaveAgendaItems) {
  yield call(services.saveAgendaItems, action.payload.meetingId, action.payload.agendaItems);
}

function* invokeChangeOrderAgendaItem(action: types.IChangeOrderAgendaItem) {
  yield call(services.changeOrder, action.payload.meetingId, action.payload.dropResult);
}

function* invokeMoveToNextAgenda(action: types.IMoveToNextAgenda) {
  yield call(services.moveStepAgenda, action.payload);
}

function* invokeMoveToNextAgendaFromNotification(action: types.IMoveToNextAgendaNotification) {
  yield call(services.storeCurrentAgenda, action.payload);
}

function* invokeSaveAgendaItemsSocket(action: types.ISaveAgendaItemsSocket) {
  yield call(
    services.saveAgendaItemsSocket,
    action.payload.meetingId,
    action.payload.agendaItems,
    action.payload.actionUserId,
  );
}

export function* watchAgendaItemsPageSaga() {
  yield takeLatest(constants.GET_AGENDA_ITEMS, invokeGetAgendaItems);
  yield takeLatest(constants.SAVE_AGENDA_ITEMS, invokeSaveAgendaItems);
  yield takeLatest(constants.CHANGE_ORDER_AGENDA_ITEM, invokeChangeOrderAgendaItem);
  yield takeLatest(constants.MOVE_STEP_AGENDA, invokeMoveToNextAgenda);

  yield takeEvery(constants.SAVE_AGENDA_ITEMS_SOCKET, invokeSaveAgendaItemsSocket);
  yield takeEvery(constants.MOVE_STEP_AGENDA_SOCKET, invokeMoveToNextAgendaFromNotification);
}
